const PackageBalanceIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2181_41202)" />
      <g clip-path="url(#clip0_2181_41202)">
        <path
          d="M47.7126 42.9552C47.7126 44.3582 47.7499 45.7015 47.6977 47.0373C47.6604 47.9478 46.9664 48.5 46.0037 48.5C43.5559 48.5075 41.1082 48.5 38.6679 48.5C34.0858 48.5 29.5037 48.4925 24.9216 48.5075C24.0559 48.5075 23.2723 48.3209 22.6082 47.7463C21.832 47.0597 21.4888 46.2015 21.4962 45.1642C21.5111 42.5672 21.4962 39.9776 21.4962 37.3806C21.4962 33.194 21.4962 29.0149 21.4962 24.8284C21.5037 23.1418 22.4738 21.8955 24.0335 21.5672C24.3096 21.5075 24.6007 21.5 24.8843 21.5C31.1082 21.5 37.3246 21.5 43.5485 21.5C44.7201 21.5 45.3395 22.1269 45.3395 23.291C45.3395 23.7239 45.3395 24.1567 45.3395 24.6269C45.1604 24.6343 45.0037 24.6493 44.847 24.6493C38.9216 24.6493 33.0037 24.6493 27.0783 24.6493C26.8917 24.6493 26.7052 24.6493 26.5186 24.6716C25.8768 24.7612 25.4365 25.2761 25.4589 25.8955C25.4813 26.5224 25.9962 27.0299 26.6529 27.0299C28.0186 27.0373 29.3843 27.0373 30.7499 27.0373C35.7798 27.0373 40.8096 27.0373 45.8395 27.0373C47.1156 27.0373 47.7276 27.6567 47.7201 28.9403C47.7201 30.2313 47.7201 31.5224 47.7201 32.8134C47.7201 32.8955 47.7126 32.9851 47.7052 33.1045C47.5634 33.1119 47.4291 33.1194 47.2947 33.1194C45.7649 33.1194 44.2425 33.1119 42.7126 33.1194C40.3022 33.1418 38.3544 34.7463 37.8693 37.1045C37.2574 40.0821 39.6231 42.9478 42.6828 42.9328C44.2126 42.9254 45.735 42.9328 47.2649 42.9254C47.3992 42.9552 47.5335 42.9552 47.7126 42.9552Z"
          fill="white"
        />
        <path
          d="M45.2199 40.9551C44.3766 40.9551 43.5333 40.9626 42.69 40.9551C41.0856 40.9402 39.802 39.679 39.7796 38.1193C39.7572 36.4775 40.9886 35.179 42.6229 35.1566C44.4214 35.1268 46.2274 35.1492 48.0259 35.1492C48.3542 35.1492 48.5109 35.291 48.5109 35.6193C48.5109 37.2462 48.5109 38.8731 48.5109 40.4999C48.5109 40.8283 48.3468 40.9701 48.0259 40.9701C47.0856 40.9477 46.1527 40.9551 45.2199 40.9551ZM43.3542 39.2462C43.996 39.2387 44.5333 38.7014 44.5408 38.0596C44.5483 37.4029 43.9886 36.8507 43.3318 36.8581C42.6826 36.8656 42.1527 37.3954 42.1453 38.0447C42.1453 38.6939 42.705 39.2537 43.3542 39.2462Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2181_41202"
          x1="35"
          y1="0"
          x2="35"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#159EB7" />
          <stop offset="1" stop-color="#007E95" />
        </linearGradient>
        <clipPath id="clip0_2181_41202">
          <rect width="27.0075" height="27" fill="white" transform="translate(21.4961 21.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PackageBalanceIconSubcategory
